import { getLocalStorageAccessToken } from '../helpers/auth';
import { NG_IMPERSONATE_FEATURE_KEY } from '../store/impersonate.slice';

export const prepareHeaders = (headers: any, api: any) => {
  const { endpoint, getState } = api || {};

  if (endpoint === 'uploadFile') {
    // Do not set the Authorization header for the uploadFile endpoint
    return headers;
  }

  const authToken = getLocalStorageAccessToken();

  if (authToken) {
    headers.set('Authorization', `Bearer ${authToken}`);
  }

  const impersonated = getState()?.[NG_IMPERSONATE_FEATURE_KEY]?.impersonated;

  if (impersonated) {
    const impersonatedToken = impersonated?.accessToken;

    if (!impersonatedToken) {
      console.error('Could not set impersonated header!. No impersonated token.');
      return;
    }

    headers.set('X-Clatter-Impersonate', `Bearer ${impersonatedToken}`);
  }

  return headers;
};
